import { createContext } from 'react';

// @ts-ignore
export const FabContext = createContext();
export const FabProvider = FabContext.Provider;
export const FabConsumer = FabContext.Consumer;
